"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TakeoutConfig',
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  computed: {
    periodFee: {
      get: function get() {
        return this.formData.periodFee;
      },
      set: function set(value) {
        this.$set(this.formData, 'periodFee', value);
      }
    },
    // 预定推送设置（兼容旧数据无该字段的情况）
    pushSetting: {
      get: function get() {
        if (!this.formData.pushSetting) {
          this.$set(this.formData, 'pushSetting', {
            selfPickup: false,
            selfPickupTime: '',
            delivery: false,
            deliveryTime: ''
          });
        }
        return this.formData.pushSetting;
      }
    },
    // 星期全选状态
    isWeekAllSelected: {
      get: function get() {
        var weeks = this.periodFee && this.periodFee.weeks || [];
        return weeks.length === 7;
      },
      set: function set(value) {
        // Vue的v-model会调用setter
      }
    },
    // 星期半选状态
    isWeekIndeterminate: function isWeekIndeterminate() {
      var weeks = this.periodFee && this.periodFee.weeks || [];
      return weeks.length > 0 && weeks.length < 7;
    }
  },
  methods: {
    addBusyTime: function addBusyTime() {
      this.formData.bsyTimeGroup.push({
        start: null,
        end: null
      });
    },
    removeBusyTime: function removeBusyTime(index) {
      this.formData.bsyTimeGroup.splice(index, 1);
    },
    /**
     * 星期全选/取消全选
     */
    handleWeekSelectAll: function handleWeekSelectAll(checked) {
      this.$set(this.periodFee, 'weeks', checked ? [1, 2, 3, 4, 5, 6, 7] : []);
    }
  }
};